export default __webpack_public_path__ + "static/media/motorcycle-hover.9e8be210.svg";